import React, { Component, Fragment } from "react";
import { Checkbox, Form } from 'antd';
import './index.less';
import InputContainer from '@/components/CreateFormItem/InputContainer';
import NumberContainer from '@/components/CreateFormItem/NumberContainer';
import SelectContainer from '@/components/CreateFormItem/SelectContainer';
import RadioContainer from '@/components/CreateFormItem/RadioContainer';
import CheckBoxContainerOther from '@/components/CreateFormItem/CheckBoxContainer';
import CascaderContainer from '@/components/CreateFormItem/CascaderContainer';
import FileContainer from '@/components/CreateFormItem/FileContainer';
import ImgContainer from '@/components/CreateFormItem/ImgContainer';
import DateContainer from '@/components/CreateFormItem/DateContainer';
import DateTimeContainer from '@/components/CreateFormItem/DateTimeContainer';
import DateTimeRangeContainer from '@/components/CreateFormItem/DateTimeRangeContainer';
export default class CheckBoxContainer extends Component {
  constructor(props) {
    super(props); // 0:单行文本;2:数字;3:日期;4:日期时间;5:日期时间范围;6:单选框;7:复选框;8:下拉框;9:级联选项;10:附件上传;11:图片

    this.detailObj = {
      'text': (value, form) => <InputContainer data-inspector-line="22" data-inspector-column="31" data-inspector-relative-path="src\\components\\CreateFormItem\\CheckBoxContainer\\index.jsx" data={value} form={form} />,
      'number': (value, form) => <NumberContainer data-inspector-line="23" data-inspector-column="33" data-inspector-relative-path="src\\components\\CreateFormItem\\CheckBoxContainer\\index.jsx" data={value} form={form} />,
      'date': (value, form) => <DateContainer data-inspector-line="24" data-inspector-column="31" data-inspector-relative-path="src\\components\\CreateFormItem\\CheckBoxContainer\\index.jsx" data={value} form={form} />,
      'dateTime': (value, form) => <DateTimeContainer data-inspector-line="25" data-inspector-column="35" data-inspector-relative-path="src\\components\\CreateFormItem\\CheckBoxContainer\\index.jsx" data={value} form={form} />,
      'period': (value, form) => <DateTimeRangeContainer data-inspector-line="26" data-inspector-column="33" data-inspector-relative-path="src\\components\\CreateFormItem\\CheckBoxContainer\\index.jsx" data={value} form={form} />,
      'radio': (value, form, list) => <RadioContainer data-inspector-line="27" data-inspector-column="38" data-inspector-relative-path="src\\components\\CreateFormItem\\CheckBoxContainer\\index.jsx" data={value} form={form} list={list} />,
      'checkbox': (value, form, list) => <CheckBoxContainerOther data-inspector-line="28" data-inspector-column="41" data-inspector-relative-path="src\\components\\CreateFormItem\\CheckBoxContainer\\index.jsx" data={value} form={form} list={list} />,
      'select': (value, form, list) => <SelectContainer data-inspector-line="29" data-inspector-column="39" data-inspector-relative-path="src\\components\\CreateFormItem\\CheckBoxContainer\\index.jsx" data={value} form={form} list={list} />,
      'cascade': (value, form) => <CascaderContainer data-inspector-line="30" data-inspector-column="34" data-inspector-relative-path="src\\components\\CreateFormItem\\CheckBoxContainer\\index.jsx" data={value} form={form} type="info" />,
      'annex': (value, form) => <FileContainer data-inspector-line="31" data-inspector-column="32" data-inspector-relative-path="src\\components\\CreateFormItem\\CheckBoxContainer\\index.jsx" data={value} form={form} />,
      'image': (value, form) => <ImgContainer.Group data-inspector-line="32" data-inspector-column="32" data-inspector-relative-path="src\\components\\CreateFormItem\\CheckBoxContainer\\index.jsx" data={value} form={form} handleImg={this.props.handleImg} />
    };
    this.state = {
      imgObj: {}
    };
  }

  render() {
    const {
      data,
      list,
      sceneCode
    } = this.props;
    const options = data.fieldOptions ? data.fieldOptions.map(value => ({
      label: value.content,
      value: value.id
    })) : [];
    const {
      getFieldDecorator,
      getFieldValue
    } = this.props.form;
    const defaultValue = data.value ? data.value.split(",").map(value => Number(value)) : [];

    if (list && list.length) {
      let nextObj = list.find(elem => elem.id === data.id);

      if (nextObj && nextObj.chooseRelList && nextObj.chooseRelList.length) {
        nextObj.chooseRelList.forEach((value, index) => {
          let obj = value.showFieldInfo;
          let childObj = list.find(elem => elem.id === obj.id);
          obj.required = true;
          obj.field = childObj.fieldName;
          obj.fieldId = childObj.id;
          obj.fieldOptions = childObj.dataOptions;
          obj.value = childObj && childObj.dataValues && childObj.dataValues.length && childObj.dataValues.map(elem => elem.fieldValue).join() || '';
          obj.fileImageValues = childObj.dataValues && childObj.dataValues.length && childObj.dataValues || null;
        });
        data.chooseRelList = nextObj.chooseRelList;
      }
    }

    const conCheckbox = getFieldDecorator(JSON.stringify(data.fieldId), {
      rules: [{
        required: data.required,
        validator: (rule, value, callback) => {
          let val = value || [];

          if (data.required && val.length === 0) {
            callback('必填项，请输入相关信息');
            return;
          } // if (val.length > data.length){
          //   callback(`最多可选${data.length}项`)
          //   return;
          // }


          callback();
        }
      }],
      initialValue: defaultValue
    })(<Checkbox.Group data-inspector-line="78" data-inspector-column="6" data-inspector-relative-path="src\\components\\CreateFormItem\\CheckBoxContainer\\index.jsx" options={options} disabled={data.frontUpdateFlag === 1} />);
    return <Fragment>
        <div data-inspector-line="82" data-inspector-column="8" data-inspector-relative-path="src\\components\\CreateFormItem\\CheckBoxContainer\\index.jsx" className="detail-sel-checkbox detail-sel-wrap">
          <Form.Item data-inspector-line="83" data-inspector-column="10" data-inspector-relative-path="src\\components\\CreateFormItem\\CheckBoxContainer\\index.jsx">
            {conCheckbox}
          </Form.Item>
        </div>
        {data.chooseRelList && data.chooseRelList.length && data.chooseRelList.map((value, index) => {
        let obj = value.showFieldInfo;
        return value.chooseFieldValue == getFieldValue(JSON.stringify(data.fieldId)) && <Form.Item data-inspector-line="90" data-inspector-column="88" data-inspector-relative-path="src\\components\\CreateFormItem\\CheckBoxContainer\\index.jsx" key={index}>
              <div data-inspector-line="91" data-inspector-column="14" data-inspector-relative-path="src\\components\\CreateFormItem\\CheckBoxContainer\\index.jsx" className="detail-sel-container">
                <span data-inspector-line="92" data-inspector-column="16" data-inspector-relative-path="src\\components\\CreateFormItem\\CheckBoxContainer\\index.jsx" className="detail-sel-title">{obj.field}{obj.required && sceneCode != 1 && <b data-inspector-line="92" data-inspector-column="93" data-inspector-relative-path="src\\components\\CreateFormItem\\CheckBoxContainer\\index.jsx">*</b> || null}</span>
                {value.fieldTip && <span data-inspector-line="93" data-inspector-column="35" data-inspector-relative-path="src\\components\\CreateFormItem\\CheckBoxContainer\\index.jsx" className="remind-span">{value.fieldTip}</span> || null}
                {this.detailObj[obj.fieldType](obj, this.props.form, list)}
              </div>
            </Form.Item> || null;
      }) || null}
      </Fragment>;
  }

}